export default __webpack_public_path__ + "img/heating.type.01.asset.e24a3649.jpg";